import api from './index'

const resource = 'offer_application_attachments'

export default {
  getAttachment (id) {
    return api.get(`${resource}/${id}/download`, { responseType: 'arraybuffer' })
  }
}
